import { ApplicationType } from "interfaces/models/ApplicationType";
import { IRequest } from "interfaces/models/IRequest";
import IRequestsResponseItem from "interfaces/responses/IRequestsResponseItem";

const mapRequestsResponseItemToRequest = (requestsResponseItem : IRequestsResponseItem) : IRequest => {
  const request : IRequest = {
    applicationId: requestsResponseItem.application.id,
    timestamp: requestsResponseItem.date,
    emailAddress: requestsResponseItem.user.email,
    site: requestsResponseItem.application.baseUrl,
    applicationType: requestsResponseItem.application.type.localeCompare("whitespace", "en", { sensitivity: "base" }) === 0
      ? ApplicationType.Whitespace : ApplicationType.HWRC,
    userId: requestsResponseItem.user.id,
    username: requestsResponseItem.user.name,
    isFederatedUser: requestsResponseItem.user.ipd !== null,
    federatedACName: requestsResponseItem.user.ipd,
    isPortalAdmin: requestsResponseItem.user.admin
  };

  return request;
};

export { mapRequestsResponseItemToRequest };
